export default __webpack_public_path__ + "static/media/gwn12.45899d44.webp";